var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    class: _vm.markerClass,
    style: _vm.style,
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseleave": function mouseleave($event) {
        return _vm.$emit('mouseleave', _vm.marker);
      },
      "click": function click($event) {
        return _vm.$emit('click', _vm.marker);
      }
    }
  }, [_vm.showText && _vm.marker.text ? [_vm._v(_vm._s(_vm.marker.text))] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }